"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTokenOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var CTokenOracleFactory = /** @class */ (function (_super) {
    __extends(CTokenOracleFactory, _super);
    function CTokenOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    CTokenOracleFactory.prototype.deploy = function (_cTokenAddress, _chainLinkTokenAggregator, _chainLinkEthAggregator, overrides) {
        return _super.prototype.deploy.call(this, _cTokenAddress, _chainLinkTokenAggregator, _chainLinkEthAggregator, overrides || {});
    };
    CTokenOracleFactory.prototype.getDeployTransaction = function (_cTokenAddress, _chainLinkTokenAggregator, _chainLinkEthAggregator, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _cTokenAddress, _chainLinkTokenAggregator, _chainLinkEthAggregator, overrides || {});
    };
    CTokenOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    CTokenOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    CTokenOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return CTokenOracleFactory;
}(contracts_1.ContractFactory));
exports.CTokenOracleFactory = CTokenOracleFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_cTokenAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_chainLinkTokenAggregator",
                type: "address",
            },
            {
                internalType: "address",
                name: "_chainLinkEthAggregator",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "BASE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "cToken",
        outputs: [
            {
                internalType: "contract ICToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainLinkTokenAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainlinkEthScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainlinkTokenScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "precisionScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
